import { useAtom } from 'jotai/react'
import { atomWithStorage } from 'jotai/utils'

import { STORAGE_KEYS } from '@/shared/constants'

interface GridLayoutOptions {
  showLang: boolean
  showUser: boolean
  showRaw: boolean
}

const gridLayoutOptionsAtom = atomWithStorage<GridLayoutOptions>(STORAGE_KEYS.GRID_LAYOUT_OPTIONS, {
  showLang: true,
  showUser: true,
  showRaw: false,
})

export const useGridLayoutOptions = () => useAtom(gridLayoutOptionsAtom)
